/**
 * MUI config module
 * @module config
 */

/** Define module API */
module.exports = {
  /** Use debug mode */
  debug: true
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/muicss/lib/js/config.js
// module id = 255
// module chunks = 0